export default __webpack_public_path__ + "static/media/x_icon.a41dfd50.svg";